var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.sidebarClasses,attrs:{"id":"app"}},[_c(_setup.Sidebar),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c(_setup.Navbar),_vm._v(" "),_c(_setup.AppMain)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }